module.exports = __webpack_public_path__ + "img/play.89bc3a7b.png";